import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Dropdown } from '@chegg-ui/dropdown'
import { ArrowIcon } from '@chegg-ui/theme'
import { ButtonContainer } from '@chegg-wt/core/components/Folders/styled'
import {
  sortOptionsList,
  sortNameToOrderByTypeMap,
} from '@chegg-wt/core/state/projects/constants'
import { SelectedType } from '@chegg-wt/core/state/projects/types'
import { OrderBy, Order } from '@chegg-wt/core/globalTypes'
import { AppState } from '@chegg-wt/core/state'
import {
  setProjectsOrder,
  setProjectsSortName,
} from '@chegg-wt/core/state/projects/actions'
import {
  projectsSortNameSelector,
  projectsOrderSelector,
} from '@chegg-wt/core/state/projects/selectors'
import * as Styled from './styled'
import { SORT_DROPDOWN_BUTTON, SORT_DROPDOWN_SORT_ORDER_BUTTON } from './testIds'

export const SORT_BY = 'Sort by'

interface SortDropDownProps {
  order: Order
  sortName: SelectedType
  setProjectsSortName: (sortName: SelectedType) => void
  setProjectsOrder: (order: Order) => void
  sortProjects: (sort: OrderBy, order: Order) => void
}

export const SortDropDown: React.FunctionComponent<SortDropDownProps> = ({
  order,
  sortName,
  sortProjects,
  setProjectsSortName,
  setProjectsOrder,
}) => {
  const onSelectValue = (sortName: SelectedType) => {
    setProjectsSortName(sortName)
  }

  const onToggleSortOrder = () => {
    const newOrder = order === Order.desc ? Order.asc : Order.desc
    setProjectsOrder(newOrder)
  }

  useEffect(() => {
    const orderBy = sortNameToOrderByTypeMap[sortName]
    sortProjects(orderBy, order)
  }, [sortName, order])

  return (
    <Styled.SortContainer>
      <Styled.Sort>
        <Styled.SortByText>Sort by:</Styled.SortByText>
        <Styled.DropdownContainer>
          <Dropdown
            options={sortOptionsList}
            onSelectValue={onSelectValue}
            value={sortName}
            labelText={SORT_BY}
            inputId="sort-citation-lists"
            width="125px"
            data-test={SORT_DROPDOWN_BUTTON}
            visuallyHideLabel
          />
        </Styled.DropdownContainer>
        <Styled.Tooltip
          position="top"
          targetElement={
            <ButtonContainer
              type="button"
              onClick={onToggleSortOrder}
              data-test={SORT_DROPDOWN_SORT_ORDER_BUTTON}
              aria-label={`Reverse sort order, currently ${
                order === 'asc' ? 'ascending' : 'descending'
              }`}
            >
              <ArrowIcon size="medium" pointing={order === Order.asc ? 'up' : 'down'} />
            </ButtonContainer>
          }
        >
          <Styled.TooltipText aria-label={`Reverse sort order: currently ${order}`}>
            Reverse <br /> sort order
          </Styled.TooltipText>
        </Styled.Tooltip>
      </Styled.Sort>
    </Styled.SortContainer>
  )
}

const mapStateToProps = (state: AppState) => ({
  sortName: projectsSortNameSelector(state),
  order: projectsOrderSelector(state),
})

const mapDispatchToProps = {
  setProjectsSortName,
  setProjectsOrder,
}

export default connect(mapStateToProps, mapDispatchToProps)(SortDropDown)
